import { render, staticRenderFns } from "./HospitalIndex.vue?vue&type=template&id=e8f0f86c&scoped=true&"
import script from "./HospitalIndex.vue?vue&type=script&lang=js&"
export * from "./HospitalIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8f0f86c",
  null
  
)

export default component.exports